import { useNavigate } from "react-router-dom";
import { EditDocumentState } from "../../../../routing/RoutingStates";
import "../css/DocumentTable.css";
import { IEditActionProps } from "../DocumentTableInterfaces";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
export default function EditAction({
  document,
  isAdvancedUser,
}: IEditActionProps) {
  const disabled = !isAdvancedUser && !document.serialNumber;
  const navigate = useNavigate();
  const handleNavigationClick = (row: any) => {
    const editDocumentState: EditDocumentState = {
      document,
    };
    navigate("EditDocument", {
      state: { editDocumentState },
    });
  };

  return (
    <Button onClick={() => handleNavigationClick(document)} 
            id={`mainPageKey-edit-${document.documentReference}`} 
            disabled={disabled}
            title="Edit Document"
            className={`${disabled ? "" : "pointer"} btn-light ms-1 btn-xs`}
            >
      <FontAwesomeIcon icon={faPencil}/>
    </Button>
  );
}
